import {useLayoutEffect, useState} from 'react';

import {
  PDP_DESKTOP_CONFIG_PANEL_MIN_WIDTH_PX,
  PDP_DESKTOP_FLYOUT_GAP_PX,
  PDP_DESKTOP_FLYOUT_WIDTH_NUDGE_PX,
} from '@amblique/king-living/app/constants/pdp-layout';

const GALLERY_SELECTOR = '.product-view__gallery-container';

/**
 * Desktop flyout width: from (gallery right + 80px) to the viewport right, min 480px.
 * Measures the live gallery so width covers the RHS without moving it.
 *
 * @param {boolean} [enabled=true]
 * @returns {string} CSS px width
 */
export function useDesktopPdpFlyoutWidth(enabled = true) {
  const [widthPx, setWidthPx] = useState(PDP_DESKTOP_CONFIG_PANEL_MIN_WIDTH_PX);

  useLayoutEffect(() => {
    if (!enabled || typeof window === 'undefined') return undefined;

    const update = () => {
      const gallery = document.querySelector(GALLERY_SELECTOR);
      const galleryRight = gallery ? gallery.getBoundingClientRect().right : 0;
      const available = document.documentElement.clientWidth - galleryRight - PDP_DESKTOP_FLYOUT_GAP_PX;

      setWidthPx(
        Math.max(
          PDP_DESKTOP_CONFIG_PANEL_MIN_WIDTH_PX,
          Math.round(available) + PDP_DESKTOP_FLYOUT_WIDTH_NUDGE_PX
        )
      );
    };

    update();
    window.addEventListener('resize', update);

    return () => window.removeEventListener('resize', update);
  }, [enabled]);

  return `${widthPx}px`;
}
